import { Committees } from '../../api';

export const getCommitteeQuery = (id: number) => ({
  queryKey: ['committees', id],
  queryFn: async () => Committees.getCommittee(id),
});
